import { useMemo } from 'react'
import { useController, Control, FieldPath } from 'react-hook-form'
import { IUseValidation } from '@wmgtech/legato'

export const useField = <TFieldValues extends Record<string, any>>(fieldName: FieldPath<TFieldValues>, control: Control<TFieldValues>) => {
  const {
    field,
    fieldState: { error }
  } = useController({
    name: fieldName,
    control,
  })

  const validation = useMemo<IUseValidation>(
    () => error ? {
      message: error?.message,
      ...(error && { type: 'error' })
    } : {},
    [error],
  )

  return {
    validation,
    field,
  }
}
